<div class="tabs">
  <ng-container *ngFor="let tab of docService.tabs">
    <button *ngIf="tab.Visible" class="q-btn tab-button" [ngClass]="{'tab-select': tab.Active}" (click)="ActiveTab(tab.Type)" [disabled]="tab.Locked"><i [ngClass]="tab.Font"></i>{{tab.Name}}</button>
  </ng-container>
</div>

<!-- Onglet de visualisation des documents -->
<div class="w-100">
  <queoval-stage-list-documents *ngIf="docService.tabs[0].Visible"
                                [ngClass]="{'d-none': !docService.tabs[0].Active }"
                                class="col-12"
                                [(refreshGrid)]="refreshData"> </queoval-stage-list-documents>
</div>

<!-- Onglet de generation des documents  -->
<div class="w-100">
  <queoval-stage-generation-documents *ngIf="docService.tabs[1].Visible"
                                      [ngClass]="{'d-none': !docService.tabs[1].Active }"
                                      class="col-12"
                                      [(refreshGrid)]="refreshData"></queoval-stage-generation-documents>
</div>

<!-- Onglet de generation des contrats formateur -->
<div class="w-100">
  <queoval-stage-generation-contrat-formateur *ngIf="docService.tabs[2].Visible"
                                              [ngClass]="{'d-none': !docService.tabs[2].Active }"
                                              class="col-12"
                                              [(refreshGrid)]="refreshData"></queoval-stage-generation-contrat-formateur>
</div>

<!-- MODAL de modification du document -->
<ng-template #ModalModifyDocument let-modal class="modal-dialog-centered">
  <div class="modal-content">
    <div class="modal-header">
      <h5 class="q-c-main">Détail du document</h5>
      <button type="button" class="close" (click)="modal.dismiss()">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="row m-1">
      <ng-container *ngIf="ShowDocument">

        <q-effectifs class="col-12 col-md-6 col-xl my-3" style="min-height:450px;" height="450px;"
                     [ListEffectifChecked]="ClientsSelected"
                     [Option]="OptionClient"
                     (EffectifToEmit)="UpdateListEffectif($event, 'REL_BO_CSOC_BO_DOCUMENT')"></q-effectifs>

        <q-effectifs class="col-12 col-md-6 col-xl my-3" style="min-height:450px;" height="450px;"
                     [ListEffectifChecked]="StagiairesSelected"
                     [Option]="OptionStagiaire"
                     (EffectifToEmit)="UpdateListEffectif($event, 'REL_BO_CONTACT_BO_DOCUMENT')"></q-effectifs>

        <q-effectifs class="col-12 col-md-6 col-xl my-3" style="min-height:450px;" height="450px;"
                     [ListEffectifChecked]="FormateursSelected"
                     [Option]="OptionFormateur"
                     (EffectifToEmit)="UpdateListEffectif($event, 'REL_BO_FORMATEUR_BO_DOCUMENT')"></q-effectifs>
      </ng-container>

      <ng-container *ngIf="ShowCourrier">

        <q-effectifs class="col-12 col-md-6 col-xl my-3" style="min-height:450px;" height="450px;"
                     [ListEffectifChecked]="ClientsSelected"
                     [Option]="OptionClient"
                     (EffectifToEmit)="UpdateListEffectif($event, 'REL_BO_CSOC_BO_COURRIER')"></q-effectifs>

        <q-effectifs class="col-12 col-md-6 col-xl my-3" style="min-height:450px;" height="450px;"
                     [ListEffectifChecked]="StagiairesSelected"
                     [Option]="OptionStagiaire"
                     (EffectifToEmit)="UpdateListEffectif($event, 'REL_BO_CONTACT_BO_COURRIER')"></q-effectifs>

        <queoval-stage-list-reservation class="col-12 col-md-6 col-xl my-3"
                                        [LstIdReservationChecked]="ReservationsSelected"
                                        (LstIdReservation)="UpdateListeReservations($event, 'REL_BO_COURRIER_BO_RESERV')"></queoval-stage-list-reservation>


        <div class="h-100 col-12 col-lg-6 col-xl-2 my-3">
          <fieldset class="q-fieldset h-100">
            <legend><i class="fas fa-chart-bar mr-2"></i>Rapport</legend>
            <div class="row report-body">
              <ng-container *ngFor="let report of docService.reportsList">
                <div [ngClass]="[selectedReport.value == report.value ? 'bold col-12 q-check radio px-1 q-pointer' : 'col-12 q-check radio px-1 q-pointer']">
                  <input type="radio" name="reports" id="report-{{report.value}}" [value]="report.value" [(ngModel)]="selectedReport.value" />
                  <label for="report-{{report.value}}" class="q-pointer">
                    <span></span>{{report.id}}
                  </label>
                </div>
              </ng-container>
            </div>
          </fieldset>
        </div>

      </ng-container>

      <ng-container *ngIf="ShowContrat">

        <queoval-stage-list-reservation class="col-12 col-md-6 col-xl my-3"
                                        [IdentFormateur]="FormateurSelected"
                                        [LstIdReservationChecked]="ReservationsSelected"
                                        (LstIdReservation)="UpdateListeReservations($event, 'REL_BO_CNT_BO_RESERV')"></queoval-stage-list-reservation>

      </ng-container>

    </div>
    <div class="row">
      <!--<button title="Regénérer le document" class="btn q-btn m-1" (click)="open(ModalGenerateValidation, false)">
        <i class="fas fa-print"></i> Regénérer doc
      </button>-->
    </div>
    <div class="row m-1">
      <q-bodisplay [item]="boDocModel" (sendEvent)="getEvent($event,ModalGenerateValidation);modal.dismiss();refreshGrid()"></q-bodisplay>
    </div>
  </div>
</ng-template>

<!-- MODAL pour remplacer un document existant -->

<ng-template #ModalReplaceDocument let-modal class="modal-dialog-centered">
  <div class="modal-content">
    <div class="modal-header">
      <button type="button" class="close" (click)="modal.dismiss()">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <q-insertdoc-input [item]="insertDocModel" (success)="OnInsert($event);modal.dismiss()" [registerMode]="'UPLOADDOCWOLINK'"></q-insertdoc-input>  
  </div>
</ng-template>


<!--  MODAL de validation de regénération des documents -->
<ng-template #ModalGenerateValidation let-modal class="modal-dialog-centered">
  <div class="modal-content">
    <div class="modal-header">
      
      <button type="button" class="close" (click)="modal.dismiss()">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="text-center">
      <div   class="q-c-main q-text-xl text-center mt-3">
        <span>{{selectedReport.value == '0' ? 'Voulez vous regénérer le document ?' : 'Voulez vous regénérer le document et les données du rapport ?'}}</span>
      </div>
      <div class="q-c-secondary q-text-s text-center mb-3">(Attention ! Vous allez remplacer le document existant.)</div>

      <div class="mb-3">
        <button class="btn q-btn m-2 p-2 q-main" type="button" (click)="RegenereDocStat();modal.dismiss()" title="Générer les documents">
          <i class="fas fa-print mr-2"></i>
          Oui
        </button>
        <button class="btn q-btn m-2 p-2 " type="button" (click)="modal.dismiss()" title="Fermer">
          <i class="fas fa-times mr-2"></i>
          Non
        </button>
      </div>
    </div>
  </div>
</ng-template>
